var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeopolitics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02084 8C5.02084 7.31516 5.04525 6.62909 5.09359 5.95831H0.262031C0.0895 6.61663 0 7.30141 0 8C0 8.69859 0.0895 9.38338 0.262031 10.0417H5.09356C5.04525 9.37091 5.02084 8.68484 5.02084 8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95801 7.99994C5.95801 8.69828 5.98326 9.38278 6.0322 10.0416H9.96713C10.0161 9.38278 10.0413 8.69828 10.0413 7.99994C10.0413 7.30163 10.0161 6.6171 9.96713 5.95825H6.0322C5.98326 6.6171 5.95801 7.30163 5.95801 7.99994Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.738 5.95831H10.9064C10.9547 6.62909 10.9792 7.31516 10.9792 8C10.9792 8.68484 10.9547 9.37091 10.9064 10.0417H15.738C15.9105 9.38338 16 8.69859 16 8C16 7.30141 15.9105 6.61663 15.738 5.95831Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12012 10.9792C6.24124 12.0473 6.4283 13.0253 6.67427 13.8551C7.11352 15.3367 7.65662 16 7.99999 16C8.34337 16 8.88646 15.3367 9.32571 13.8551C9.57168 13.0252 9.75874 12.0473 9.87987 10.9792H6.12012Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87987 5.02081C9.75874 3.95266 9.57168 2.97469 9.32571 2.14491C8.88646 0.663219 8.34337 0 7.99999 0C7.65662 0 7.11352 0.663219 6.67427 2.14491C6.4283 2.97472 6.24124 3.95269 6.12012 5.02081H9.87987Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4283 5.02087C15.0312 4.03015 14.434 3.12065 13.6566 2.34318C12.5049 1.19146 11.0636 0.43468 9.49707 0.139648C10.1584 1.22059 10.6031 3.01034 10.8216 5.02084H15.4283V5.02087Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49707 15.8603C11.0636 15.5653 12.5048 14.8086 13.6566 13.6568C14.434 12.8793 15.0312 11.9699 15.4283 10.9791H10.8216C10.6031 12.9897 10.1584 14.7794 9.49707 15.8603Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.571381 10.9792C0.968506 11.9699 1.56569 12.8794 2.34313 13.6568C3.49488 14.8086 4.9361 15.5654 6.5026 15.8604C5.84122 14.7795 5.39657 12.9897 5.1781 10.9792L0.571381 10.9792Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5026 0.139618C4.9361 0.434618 3.49488 1.1914 2.34313 2.34315C1.56569 3.12062 0.968506 4.03009 0.571381 5.02084H5.1781C5.39657 3.01031 5.84122 1.22056 6.5026 0.139618Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeopolitics);
export default __webpack_public_path__ + "static/media/geopolitics.925c6a7c13d5074cf11e5441f1669048.svg";
export { ForwardRef as ReactComponent };